export default "__VITE_ASSET__86sMk0Nu__"